<template>
    <div class="container"  v-title="'赛事广场'">
        <Navigation-bar v-scrollShadow="scrollTop">
            <template v-if="showType">
                <template slot="left">
                    <div class="nav_title" @click="project.show = !project.show">
                        <span>项目</span>
                        <YD-image :src="project.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
                    </div>
                </template>
                <template slot="title">
                    <div class="status">
                        <div :class="{'active': status == 1}" @click="selectStatus(1)">未结束</div>
                        <div :class="{'active': status == 2}" @click="selectStatus(2)">已结束</div>
                    </div>
                </template>
            </template>
            <template slot="title" v-else>
                <div class="nav_title" v-if="scrollTop > titleTop" @click="project.show = !project.show">
                    <span>{{project.name}}</span>
                    <YD-image :src="project.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
                </div>
            </template>
            <template slot="action">
                <YD-image src="icon/icon_search_black" class="search" @click.native="search"></YD-image>
                <YD-image src="icon/icon_nav_分享" class="share"
                    v-share="shareConfig" 
                    v-if="$appVersion >= '22093000'"
                ></YD-image>
            </template>
        </Navigation-bar>
        <div class="container_content">
            <div id="Match_list" ref="Match_list">
                <Scroll
                    ref="scroll"
                    lazy
                    @scrollChange="scrollTop = $event"
                    @scrollEnd="scrollEnd"
                >
                    <Pull-refresh
                        v-model="PullRefresh.loading" 
                        loosing-text="释放刷新数据"
                        loading-text="正在刷新数据..." 
                        :success-text="PullRefresh.text" 
                        @refresh="onRefresh"
                    >
                        <div class="ML_content" :style="!showType || 'padding-top: 0.4rem;'">
                            <template v-if="!showType">
                                <div class="title">
                                    <h2>
                                        <div v-show="project.name" @click="project.show = !project.show">
                                            <span>{{project.name}}</span>
                                            <YD-image :src="project.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
                                        </div>
                                    </h2>
                                    <p class="subTitle">赛事广场</p>
                                </div>
                            </template>
                            <ul class="list">
                                <li class="banner" @click="goSerial()" v-if="serialEnd" v-show="list.length && [8, 801, 802].includes(project.Id) && status == 2">
                                    <YD-image src="serial_match/banner_1"></YD-image>
                                </li>
                                <li 
                                    v-for="({
                                            Description,
                                            GameTime,
                                            CurrentCertificate,
                                            SubLeagueId,
                                            Status,
                                            AbnormalStatus,
                                            GamePlaces
                                        },index) in list" :key="`${index}_${SubLeagueId}`"
                                        @click="goDetail(SubLeagueId)"
                                >
                                    <div class="img_box" lazy-box :style="{'background-image': `url(${Description.CoverThumbUrl})`}">
                                        <img :lazy-src="Description.LogoUrl">
                                        <div class="top">
                                            <img class="events" :src="`https://file.dazhongyundong.com/static/events/${Description.EventsId}_26.png`">
                                        </div>
                                        <div class="bottom">
                                            <div class="location">
                                                <YD-image src="icon/icon_卡片_位置"></YD-image>
                                                <span v-html="GamePlaces ? GamePlaces.join(`<i>/</i>`) : '未知'"></span>
                                            </div>
                                            <template v-if="AbnormalStatus == 1">
                                                <div class="match_status"><span class="error">赛事取消</span></div>
                                            </template>
                                            <template v-else>
                                                <div class="match_status" v-if="Status == 1">
                                                    <span style="color: #FD9D08;">待报名</span>
                                                </div>
                                                <div class="match_status" v-else-if="Status == 2">
                                                    <span style="color: #81E711;">报名中</span>
                                                </div>
                                                <div class="match_status" v-else-if="Status == 3">
                                                    <span class="error" v-if="AbnormalStatus == 2">赛事延期</span>
                                                    <span style="color: #FD9D08;" v-else>未开赛</span>
                                                </div>
                                                <div class="match_status" v-else-if="Status == 4">
                                                    <span class="error" v-if="AbnormalStatus == 3">赛事中断</span>
                                                    <span style="color: #FF4D13;" v-else>比赛中</span>
                                                </div>
                                                <div class="match_status" v-else-if="Status == 5">
                                                    <span style="color: #FFFFFF;">已结束</span>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="match_info">
                                        <p class="name" :style="CurrentCertificate.Level?'width:calc(100% - 1rem)':'width:100%'">{{Description.Name}}</p>
                                        <p class="date">
                                            <template v-if="GameTime">{{GameTime.BeginTime | dateFormat('yyyy年MM月dd日')}} - {{GameTime.EndTime | dateFormat('yyyy年MM月dd日')}}</template>
                                            <template v-else>{{['','','比赛时间待定','恢复时间待定'][AbnormalStatus]}}</template>
                                        </p>
                                        <YD-image v-if="CurrentCertificate.Level" :src="`icon/icon_赛事等级徽章_${CurrentCertificate.Level}级`" @click.native.stop="lookOverCertificate(CurrentCertificate.CertificateNumber,CurrentCertificate.Level)"></YD-image>
                                    </div>
                                </li>
                            </ul>
                            <div class="load_more" v-show="loadMore">
                                <img src="@images/no_data/暂无赛事证书@2x.png" v-show="loadMore == '无数据'">
                                <span v-show="loadMore != '无数据'">{{loadMore}}</span>
                            </div>
                        </div>
                    </Pull-refresh>
                </Scroll>
                <div class="masking" v-show="project.name && project.show" @click="project.show = false"></div>
                <div id="project_list" v-show="project.name && project.show">
                    <template v-if="!showType">
                        <div class="title" v-show="scrollTop <= titleTop">
                            <h2>
                                <div v-show="project.name" @click="project.show = !project.show">
                                    <span>{{project.name}}</span>
                                    <YD-image :src="project.show ? 'icon/icon_下拉箭头_黑色_向上' : 'icon/icon_下拉箭头_黑色_向下'"></YD-image>
                                </div>
                            </h2>
                            <p class="subTitle">赛事广场</p>
                        </div>
                    </template>
                    <div class="project_list_content">
                        <ul>
                            <li v-for="(item,index) in project.list" :key="index" 
                                :class="{'active': item.Id == project.Id}"
                                @click="projectChange(item)"
                            >
                                {{item.Name}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div id="certificate" v-show="certificateShow" @click="()=>{this.certificateShow = false}">
            <div class="certificate_modal">
                <div class="certificate_content" >
                    <YD-image class="medal" :src="'certificate/icon_证书_'+certificateInfo.Level+'级赛事'"></YD-image>
                    <div class="competition_name">
                        <div class="competition_name-content">
                            <p v-for="item in LeagueNames" :key="item">{{item}}</p>
                        </div>
                    </div>
                    <YD-image class="grade" :src="'certificate/文字_'+certificateInfo.Level+'级赛事'"></YD-image>
                    <div class="certificate_serialNumber">证书编号：{{certificateInfo.CertificateNumber}}</div>
                    <div class="certificate_date">{{certificateInfo.IssueDate | dateFormat('yyyy年MM月dd日')}}</div>
                    <div class="certificate_stamp"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { PullRefresh } from 'vant';
import 'vant/lib/pull-refresh/style';
import appInteraction from "@/common/appInteraction.js";
import tools from '@/common/tools.js';
export default {
    name: 'MatchList',
    components:{
        PullRefresh
    },
    data() {
        return {
            scrollTop: 0,//滚动距离
            project:{
                name: "",
                Id: -1,
                list: [],
                show: false
            },
            includeSubEvents: false,
            list:[],
            lastId:0,
            loadMore:'',
            isGetData:true,
            certificateInfo:{},//证书信息
            certificateShow:false,//证书显示
            PullRefresh:{
                loading:false,
                text:''
            },
			status: 1,
            serialEnd: false
        };
    },
    created(){
        let eventsId = this.$route.query.eventsId,
            eventsName = this.$route.query.eventsName;
        if(eventsId != undefined ){
            this.project.Id = eventsId;
            this.project.name = eventsName || '项目';
            this.includeSubEvents = true;
        }else{
            this.project.Id = 0;
            this.project.name = "全部项目";
        }
        this.getListData(this.status, 0, false, true);
        this.$api.GetEventsFlatedList().then(data=>{
            if(data.Code == 0){
                var arr = data.EventsList;
                var all = {Id:0,Name:'全部项目'};
                arr.unshift(all);
                this.project.list = arr;
            }
        })
        appInteraction.backTop(()=>{
            this.$refs.scroll.scrollTo({
                scrollTop: 0,
                behavior: 'smooth'
            })
        })
        appInteraction.refreshPageData(data=>{
            let { EventsId } = data || {};
            this.project.Id = EventsId || 0;
            this.project.name = "项目";
            this.includeSubEvents = true;
            this.status = 1;
            this.getListData(this.status, 0, false, true);
        })
        this.$api.CheckLeagueSerialHaveCompletedLeague({
            LeagueSerialId: 1
        }).then(data=>{
            if(data.Code == 0){
                this.serialEnd = data.IsHave;
            }
        })
    },
    computed:{
        titleTop(){
            return tools.remToPx(110);
        },
        showType(){
            let eventsId = this.$route.query.eventsId;
            return tools.isVersion('23071012') || (tools.isVersion('23040300') && !eventsId);
        },
        shareConfig(){
            return {
                Type: 1,
                Title: '赛事广场',
                Text: '亿万职工动起来',
                Link: 'https://m.dazhongyundong.com/app_download/',
                LinkText: '立即下载APP：',
                ImgLink: ''
            }
        },
        LeagueNames(){
            let {
                LeagueNameByLines,
                LeagueName
            } = this.certificateInfo;
            if(LeagueNameByLines){
                return LeagueNameByLines.split(',');
            }
            return [LeagueName];
        }
    },
    watch:{
        'project.show':{
            deep: true,
            handler(newVal){
                if(newVal && this.scrollTop < this.titleTop){
                    this.$refs.scroll.scrollTo({
                        scrollTop: 0,
                        behavior: 'smooth'
                    })
                }
            }
        }
    },
    methods: {
        projectChange({Id, Name}){
            //if(this.project.Id != Id){
                this.project.Id = Id;
                this.project.name = Name;
                this.includeSubEvents = false;
                this.project.show = false;
                this.getListData(this.status, 0);
            //}
        },
        selectStatus(status){
            if(this.status != status){
                this.status = status;
                this.getListData(status, 0);
            }
        },
        search(){
            if(this.showType){
                appInteraction.webviewOpenUrl(process.env.VUE_APP_PUBLIC_URL+ '/#/Match/MatchSearch');
            }else{
                this.$navigation.go('/Match/MatchSearch');
            }
        },
        goDetail(SubLeagueId){
            if(this.showType){
                appInteraction.webviewOpenUrl(process.env.VUE_APP_PUBLIC_URL + '/#/Match/MatchDetail/'+ SubLeagueId);
            }else{
                this.$navigation.go('/Match/MatchDetail/'+ SubLeagueId);
            }
        },
        goSerial(){
            appInteraction.webviewOpenUrl(process.env.VUE_APP_PUBLIC_URL + '/#/SerialMatch/MatchHome/1');
        },
        scrollEnd(){
            if(!this.isGetData){ 
                return ;
            }
            this.getListData(this.status, this.lastId);
        },
        getListData(status, lastId, isRefresh, init){
            if(lastId == 0){
                this.lastId = 0;
                if(!isRefresh){
                    this.list = [];
                }
            }
            
            if(!isRefresh){
                this.isGetData = false;
                this.loadMore = '数据加载中...';
            }
            this.$api.GetSubLeagueList({
                Continuation: {
                    LastId: lastId,
                    MaxCount: 20
                },
                EventsId: this.project.Id,
                IncludeSubEvents: this.includeSubEvents,
                LeagueNameKeyword: '',
				QueryStatus: this.showType ? status : null
            }).then(data=>{
                this.isGetData = true;
                this.loadMore = '';
                this.PullRefresh.loading = false;
                if(data.Code == 0){
                    let list = data.ContinuedList || []; 
                    if(isRefresh){
                        this.PullRefresh.text = "数据刷新成功";
                    }
                    if(list.length){
                        if(lastId == 0){
                            this.list = data.ContinuedList;
                        }else{
                            this.list.push.apply(this.list, list);
                        }
                        this.lastId = list[list.length-1].SubLeagueId;
                    }else{
                        if(lastId == 0){
                            this.loadMore = '无数据';
                        }else{
                            this.loadMore = '到底了';
                        }
                        this.isGetData = false;
                    }
                    if(this.showType && init && !list.length){
                        this.status = this.status == 1 ? 2 : 1;
                        this.getListData(this.status, 0);
                    }
                }else{
                    if(isRefresh){
                        this.PullRefresh.text = "数据刷新失败";
                    }
                }
            }).catch(err=>{
                if(isRefresh){
                    this.PullRefresh.loading = false;
                    this.PullRefresh.text = "数据刷新失败";
                }else{
                    this.isGetData = true;
                    this.loadMore = '';
                }
            })
        },
        onRefresh(){
            this.getListData(this.status, 0, true)
        },
        lookOverCertificate(CertificateNumber,Level){
            if(CertificateNumber){
                this.$api.GetLeagueCertificate({
                    CertificateNumber
                }).then(data=>{
                    if(data.Code == 0){
                        this.certificateInfo = data.LeagueCertificate;
                        this.certificateShow = true;
                    }
                })
            }else{
                this.$Prompt({
                    title: '初审评定',
                    message: `初审评定为${Level}级赛事，终审通过后发放证书`,
                    confirmText: '关闭',
                    confirmColor: '#3A3F49'
                })
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.nav_title{
    width: auto;
    height: 50px;
    font-size: 36px;
    color: #1B1C1E;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 32px;
        height: 32px;
        margin-left: 4px;
        margin-top: 1px;
    }
}
.share,
.search{
    width: 48px;
    height: 48px;
    margin-right: -6px;
}
.search + .share{
    margin-left: 30px;
}
.status{
    width: 308px;
    height: 64px;
    background: rgba(118,118,128,0.12);
    border-radius: 16px;
    padding: 4px;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
    div{
        flex: 1;
        height: 56px;
        box-sizing: border-box;
        font-family: PingFangSC-Regular;
        font-size: 26px;
        color: #1B1C1E;
        line-height: 56px;
        font-weight: 400;
        text-align: center;
        &.active{
            background: #FFFFFF;
            border: 1px solid rgba(0,0,0,0.04);
            box-shadow: 0px 6px 16px 0px rgba(0,0,0,0.12);box-shadow: 0px 6px 2px 0px rgba(0,0,0,0.04);
            border-radius: 12px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
        }
        &:nth-of-type(1){
            padding-left: 13px;
            &.active{
                padding-right: 13px;
            }
        }
        &:nth-of-type(2){
            padding-right: 13px;
            &.active{
                padding-left: 13px;
            }
        }
        
    }
    
}
#Match_list{
    height: 100%;
    position: relative;
    overflow: hidden;
    .ML_content{
        padding-bottom: 40px;
    }
    .title{
        width: 100%;
        height: 194px;
        padding: 24px 40px 0;
        box-sizing: border-box;
        &.fixed{
            position: absolute;
            left: 0;
            z-index: 3;
        }
        h2{
            display: inline-block;
            @include line-height(84px);
            font-size: 60px;
            color: #1B1C1E;
            font-weight: 500;
            position: relative;
            img{
                width: 40px;
                margin-left: 12px;
                margin-top: 30px;
            }
        }
        p.subTitle{
            @include line-height(44px);
            font-size: 32px;
            color: #8B8C8D;
            font-weight: 400;
            margin-top: 6px;
        }
    }
    .list{
        width: 670px;
        margin: 0 auto;
        li{
            height: 532px;
            width: 670px;
            margin-bottom: 24px;
            &.banner{
                height: 140px;
                border-radius: 0;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .img_box{
                height: 376px;
                width: 100%;
                position: relative;
                border-radius: 20px 20px 0 0;
                overflow: hidden;
                background: #D8D8D8;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
                >img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .top{
                    width: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: flex;
                    justify-content: center;
                    .events{
                        width: auto;
                        height: 52px;
                    }
                }
                .bottom{
                    width: 100%;
                    height: 188px;
                    background-image: linear-gradient(180deg, rgba(63,63,63,0.00) 11%, rgba(62,62,62,0.04) 20%, rgba(60,60,60,0.09) 29%, rgba(58,58,58,0.14) 35%, rgba(56,56,56,0.19) 42%, rgba(54,54,54,0.24) 50%, rgba(51,51,51,0.30) 57%, rgba(49,49,49,0.36) 62%, rgba(46,46,46,0.42) 68%, rgba(43,43,43,0.49) 72%, rgba(39,39,39,0.55) 77%, rgba(36,36,36,0.61) 83%, rgba(32,32,32,0.67) 87%, rgba(27,27,27,0.74) 91%, rgba(21,21,21,0.80) 100%);
                    padding: 118px 20px 0 32px;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    .location{
                        width: calc(100% - 150px);
                        font-size: 26px;
                        color: #FFFFFF;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                        img{
                            width: 32px;
                            height: 32px;
                            margin-right: 6px;
                        }
                        span{
                            width: calc(100% - 40px);
                            @include ellipsis;
                            ::v-deep i{
                                font-style: normal;
                                color: #C8C8C8;
                                font-weight: 400;
                                margin:0 8px;
                            }
                        }
                    }
                    
                    .match_status{
                        font-size: 26px;
                        letter-spacing: 0;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                        img{
                            width: 32px;
                            height: 32px;
                            margin-right: 6px;
                        }
                        span{
                            @include line-height(40px);
                            min-width: 120px;
                            text-align: center;
                        }
                        span.error{
                            background: rgba(77,34,20,0.70);
                            border-radius: 4px;
                            color: #FF4D13;
                            padding: 0 8px;
                        }
                    }
                }
            }
            .match_info{
                height: 140px;
                background: #FFFFFF;
                box-shadow: 0 10px 19px 0 #EBF2F5;
                border-radius: 0px 0px 20px 20px;
                padding: 30px 32px;
                box-sizing: border-box;
                position: relative;
                .name{
                    width: 100%;
                    line-height: 44px;
                    font-size: 32px;
                    color: #1B1C1E;
                    font-weight: 500;
                    @include ellipsis;
                }
                .date{
                    width: 100%;
                    font-size: 28px;
                    color: #7E7E7F;
                    line-height: 40px;
                    font-weight: 400;
                    margin-top: 8px;
                }
                img{
                    width: 100px;
                    height: 100px;
                    position: absolute;
                    top: 20px;
                    right: 32px;
                }
            }
        }
    }
    .masking{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.4);
        z-index: 2;
    }
    #project_list{
        width: 100%;
        height: auto;
        background: #FFFFFF;
        border-radius: 0px 0px 40px 40px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        .project_list_content{
            padding: 24px 0 24px 42px;
            box-sizing: border-box;
            ul{
                display: flex;
                flex-wrap: wrap;
                li{
                    width: 156px;
                    @include line-height(74px);
                    background: #FAFBFA;
                    border-radius: 37px;
                    font-size: 24px;
                    color: #333333;
                    text-align: center;
                    font-weight: 400;
                    margin-right: 16px;
                    margin-bottom: 16px;
                    &.active{
                        background: #1B1C1E;
                        color: #FFFFFF;
                        font-weight: 600;
                    }
                }
            }
        }
    }
}
@include certificate;
</style>